exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".project-list[data-v-364c22ce]{cursor:pointer}", ""]);

// exports
